import { render, staticRenderFns } from "./pointsMall.vue?vue&type=template&id=acdb057c&scoped=true&"
import script from "./pointsMall.vue?vue&type=script&lang=js&"
export * from "./pointsMall.vue?vue&type=script&lang=js&"
import style0 from "./pointsMall.vue?vue&type=style&index=0&id=acdb057c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acdb057c",
  null
  
)

export default component.exports